import { render, staticRenderFns } from "./program_settings.vue?vue&type=template&id=7bde9dba&scoped=true&lang=html&"
import script from "./program_settings.vue?vue&type=script&lang=js&"
export * from "./program_settings.vue?vue&type=script&lang=js&"
import style0 from "./program_settings.vue?vue&type=style&index=0&id=7bde9dba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bde9dba",
  null
  
)

export default component.exports